import { createApp } from "vue";
import App from "./App.vue";
// 自定义 全局 css
import "@/views/styles/_global.scss";
import "@/views/styles/reset.scss";
import "@/views/styles/common.scss";
import "@/views/styles/_flex.scss";
import "@/views/styles/_mixins.scss";
import "@/views/styles/_spacing.scss";
import "@/views/styles/_grid.scss";
// custom element css
import "@/views/styles/element.scss";
import "@/views/assets/iconfont/iconfont.css";
import "element-plus/dist/index.css";
import "vant/lib/index.css";
import "zhihao-ui/dist/index.css";

// svg icons
import "virtual:svg-icons-register";
// element icons
import * as Icons from "@element-plus/icons-vue";
// custom directives
import directives from "@/views/directives/index";
// vue Router
import router from "@/routers";
// pinia store
import pinia from "@/stores";
// 预加载全局组件
import * as preComp from "@/utils/preComp";
import {
    Field,
    Button,
    Search,
    Popup,
    DatePicker,
    TimePicker,
    PickerGroup,
    Collapse,
    CollapseItem,
    Popover, Tab, Tabs, Checkbox, CheckboxGroup, Toast
} from "vant";

const clearCaches = async () => {
    if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    }
};

clearCaches();


const app = createApp(App);

Object.keys(preComp).forEach(key => {
    app.component(key, preComp[key as keyof typeof preComp]);
});

// register the element Icons component
Object.keys(Icons).forEach(key => {
    app.component(key, Icons[key as keyof typeof Icons]);
});

app.use(Search);
app.use(Button);
app.use(Popup);
app.use(Field);
app.use(DatePicker);
app.use(TimePicker);
app.use(PickerGroup);
app.use(Collapse);
app.use(CollapseItem);
app.use(Popover);
app.use(Tab);
app.use(Tabs);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(Toast);
app.use(directives).use(router).use(pinia).mount("#app");
